import {
  defaultBaseQuery,
  transformErrorResponse,
  transformSuccessResponse,
} from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const studentProfileAPI = createApi({
  reducerPath: "studentProfileAPI",
  baseQuery: defaultBaseQuery,
  tagTypes: ["StudentRecords"],
  endpoints: (builder) => ({
    getStudentRecordsList: builder.query({
      query: (params) => ({
        url: `/student/records/all`,
        method: "GET",
        params,
      }),
      transformResponse: (response) => response,
      transformErrorResponse: transformErrorResponse,
      providesTags: ["StudentRecords"],
    }),
    getStudentProfile: builder.query({
      query: (params) => ({
        url: `/student/register`,
        method: "GET",
        params,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
    }),
    updateStudentStatus: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/student/records/${id}/status`,
        method: "PATCH",
        body,
      }),
      transformResponse: transformSuccessResponse,
      transformErrorResponse: transformErrorResponse,
      invalidatesTags: ["StudentRecords"],
    }),
  }),
});

export const {
  useLazyGetStudentRecordsListQuery,
  useLazyGetStudentProfileQuery,
  useUpdateStudentStatusMutation,
} = studentProfileAPI;

export default studentProfileAPI;
